<template>
  <div id="PaSchoolFinder">
    <!-- School finder -->
    <v-card class=" card--flex-toolbar  mt-1 mb-5 pt-0" flat >


      <div  class="mt-5 pt-5">

        <v-container class="px-0">
              <v-list class="background pt-1 mt-0" three-line  subheader>

            <v-card  v-for="school in filteredSchools"
              :key="school.id"
              avatar

              tile class="mx-3 mt-3 tileCard ">

            <v-list-tile
               @click="moreInfo(school.school_name)"

            >
              <v-list-tile-avatar class="mt-1">
                <img :src="school.program_image" alt="">
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title >{{ school.school_name }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ school.program_state }}</v-list-tile-sub-title>
                <v-list-tile-sub-title><v-icon color="red lighten-2" small>today</v-icon>{{school.application_deadline | removeTimeFromDate | moment(" MMMM Do, YYYY")}}</v-list-tile-sub-title>
                 <!-- <span class="caption ">{{school.application_deadline | moment(" MMMM Do, YYYY")}}</span> -->
              </v-list-tile-content>

              <v-list-tile-action >

                <v-btn class="" icon round :ripple="false" >
                  <v-icon color="grey">keyboard_arrow_right</v-icon>
                </v-btn>



              </v-list-tile-action>

            </v-list-tile>
            </v-card>

          </v-list>
        </v-container>

      </div>
    </v-card>
  </div>
</template>

<script>
  export default {
    props: ['filteredSchools'],
    data () {
      return {
        showFilter : false,
        showResults : false,
        searchStatus: 'Any Status',
        searchPaShadowing : this.maxPaShadowingHours,
        searchState: 'All States',
        searchMinGpa: '',
        searchOverallGpa: 4.0,
        searchScienceGpa: 4.0,
        healthcareExperience: '',
        minimumHealthcareHours : '',
        paShadowing: '',
        gre: '',
      }
    },
    methods: {
      back() {
        this.$router.go("-1");
      },
      moreInfo (id) {
        console.log(id)
         this.$router.push("/paschool/" + id.split(' ').join('-'));
      }
    },
    computed : {


    }
  }
</script>

<style scoped >

.background {
  background-color: rgb(255, 255, 255);
}

    .buttonFixed {
    position: fixed;
    bottom: 0;
    left: 0;

  }

  .fixed{
    position: fixed;
  }

  .fixedHeader {
    position: fixed;

    display: flex;
    align-items: center;
    justify-content: center;
  }

      #buttonShadow {
  box-shadow: 0 10px 30px -10px #11111130;
}

      .buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}

  .buttonFixed {
    position: fixed;
    bottom: 0;
    left: 0;

  }

  .tileCard {
  border-radius: 10px;
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}

</style>



// WEBPACK FOOTER //
// src/components/PaSchoolFinder/SchoolMatchResults.vue